import * as Funzioni from './functions';

$(document).ready(function(){
    Funzioni.init();
});